<template>
  <header class="subnav subnav-filters">
    <div class="container d-flex align-items-center justify-content-between">
      <div class="navbar-group"></div>
      <div class="navbar-group actions show">
        <RouterLink :to="{ name: 'support-districts' }" style="text-decoration: none; color: unset">
          <button
            type="button"
            :class="[{ selected: $router.currentRoute.value.name === 'support-districts' }]"
            data-cy="nav-directory-btn"
          >
            <v-icon>mdi-office-building</v-icon>
            <span>Districts</span>
          </button>
        </RouterLink>
        <RouterLink :to="{ name: 'support-accounts' }" style="text-decoration: none; color: unset">
          <button
            type="button"
            :class="[{ selected: $router.currentRoute.value.name === 'support-accounts' }]"
            data-cy="nav-directory-btn"
          >
            <v-icon>mdi-warehouse</v-icon>
            <span>Schools</span>
          </button>
        </RouterLink>
        <RouterLink :to="{ name: 'support-leads' }" style="text-decoration: none; color: unset">
          <button
            type="button"
            :class="[{ selected: $router.currentRoute.value.name === 'support-leads' }]"
            data-cy="nav-leads-btn"
          >
            <v-icon>mdi-account-star-outline</v-icon>
            <span>Leads</span>
          </button>
        </RouterLink>
        <RouterLink :to="{ name: 'support-trials' }" style="text-decoration: none; color: unset">
          <button
            type="button"
            :class="[{ selected: $router.currentRoute.value.name === 'support-trials' }]"
            data-cy="nav-trials-btn"
          >
            <v-icon>mdi-gift-open-outline</v-icon>
            <span>Trials</span>
          </button>
        </RouterLink>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
.navbar-group.actions {
  button {
    @include breakpoints.media-breakpoint-down(sm) {
      span {
        font-size: 13px !important;
      }
    }
    &.selected {
      color: $primary !important;
      box-shadow: 0 0 0 0.125rem rgba(128, 12, 27, 0.125);
    }
  }
}
</style>
